import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminDashboard = () => {
    return <Navigate to="/dashboard/policies" />;
};

export default AdminDashboard;
